<template>
  <div class="full-screen-overlay bg-primary opacity-25">
    <div class="spinner-border" style="width: 10rem; height: 10rem" role="status">
      <span class="visually-hidden">Loading... </span>
    </div>
  </div>
  <div class="alert alert-success mt-2" role="alert" v-if="state.success.value.message">
    {{ state.success.value.message }}
  </div>
  <div class="alert alert-warning mt-2" role="alert" v-if="state.warnings.value.length">
    <div class="mb-2" v-for="w in state.warnings.value">
      <h3 v-if="w.message">{{ w.message }}</h3>
    </div>
  </div>
  <div class="alert alert-danger mt-2" role="alert" v-if="state.errors.value.length">
    <div class="mb-2" v-for="e in state.errors.value">
      <h3 v-if="e.message">{{ e.message }}</h3>
      <p v-else>{{ e }}</p>
      <h6 v-if="e.url">{{ e.url }}</h6>
      <pre v-if="e.stack" class="mt-3">
        {{ e.stack }}
      </pre>
      <ul v-if="e.stackTrace" class="mt-3 mb-5">
        <li v-for="line in e.stackTrace.split('\n')">{{ line }}</li>
      </ul>
      <ul v-if="e.invalidProperties">
        <li v-for="p in e.invalidProperties">{{ p.errorMessage }}</li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from "vue"
import { useRouter } from "vue-router"
import { useNotification, clearNotifications } from "./Notification"

// the component half of components/Notification.js, which stays a plain module: the notification
// STORE (state + setters) is imported by ~35 files that have nothing to do with this markup
defineOptions({ name: "Notification" })

const props = defineProps({
  noRouter: {
    type: Boolean,
    default: false,
  },
})

const { state } = useNotification()
const router = useRouter()

if (!props.noRouter) {
  // clear notification on route change if seen
  if (router) {
    router.afterEach((to, from) => {
      if (to.params.keepMessages !== "true") {
        clearNotifications()
      }
    })
  }
}

onMounted(() => {
  if (state.loading.value) {
    document.body.classList.add("show-loader")
  } else {
    document.body.classList.remove("show-loader")
  }
})
</script>
